import Image from 'next/image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/ListView.module.css';
import * as LIB from '../../lib/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/fontawesome-free-regular';

const Listing = ({ listData, typeName, typeID, dateFiltered }) => {
    const clockIcon = <FontAwesomeIcon icon={faClock} />;

    const renderLink = (post) => {
        if (post.id && typeID != 'vid') {
            return (LIB.getBasepath(`/posts/${post.id}/` + encodeURIComponent(post.title.replace(/ /g, ''))));
        } else if (typeID == 'vid' && post.code) {
            return ('https://www.youtube.com/watch?v=' + post.code);
        } else {
            return ('javascript:void(0)');
        }
    }

    const renderCardContent = (article) => {
        return (
            <a href={renderLink(article)} target={typeID == 'vid' || dateFiltered == true ? '_blank' : '_self'}>
                <div className={styles.card}>
                    <div className={styles.imgHolder}>
                        {
                            article.thumbnail && <Image
                                src={article.thumbnail}
                                alt="圖片"
                                layout="responsive"
                                sizes="100vw"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                                height={220}
                                width={400}
                                placeholder='blur'
                                blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbkAAAEjBAMAAABdh2I+AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAB3RJTUUH4gcCDywPLaM1sAAAACRQTFRFUVFRWVlZaWlpdXV1goKCjo6OmpqasrKyvr6+zs7O5+fn////u/y1kQAAAAFiS0dECx/XxMAAAAN3SURBVHja7dq/b9NAFMBxIxA/F1yg6ljWbsgFCTp2Ql2AyilqFxCqgWZBQipCmWCo0mbpAKhuFn6ohcQLqkhbn/857DtbSWiTLrTWvXzfdI6zfPTeveez7CSC47eDDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh26kdG1BeviJ+6NmlSdeuy67lhTqO6Hm8WEUN0drXObInUHBufOCNJ98Rcis9rLdRNydJ89z7tnlh9y3S0xusPZVOct6vXzXDcmRvcpw3l3+3SuGN281nkNkbmLDc5b6t13N6Xo9nPdg+zie64bl6Lr5Lr7+iLXTZm0LleaknTqttFVdVavO865miBd8rE77tSkk8b5yGrdQa6bM8Wok6c7zDdHx5TVOjVrdFVzuZviHurVpNFdsHvevdW46aICW+/WTU6dPBpW6zo9264n9grdjNW65EWWuiMZ2ix0V+3WHc570ytHfn1T6K5Yfr5T4TFD+1mhuyznzcOo6DalVOax8bXQXbNVN+wp60+hW7JTFy/7r4fcLXSRlTq17Pv+yuD7jwzuop1PYjspzq8MzkzH6Kp26rLU+X71hJlwyc7zXaxx/uKQ0k1545Gdun2jWxj2n9a2re9VOkZXSUqM09PtiNbJzl2+757K1J3cM23W5fOuJlS3f+JAsFmnk1cTq1NrwUYiVld+oEOHDh06dOjQjaxOtQXr4tXgvVidWg2CQOwJ6CDFBS+l6tYyXdAUqtO4ckvz9HTK6FbQoWPf0TP/U+yKnneq9G13qs+ZP4PgVSRWl7TCUT7fqXY7kqtrpyFWp+TrInRUZnm6ARmSoduq1yOxE+FXvV5fH5A8+6d5PYtSzgpnoFNa1xCqi7VuQ6jusF/XCrfl5k6FYdgUq2ululCQrr9nZrgwEqTbynRRtzBl6eJ/tp0sXRJvddukPF1vhNK6Sl9kPXNbrE6dYWGWcHpV4dl9K8AXHejQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDh06dOjQoUOHDp0Q3V/jIkYAeoOPvAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0wMlQxNTo0NDoxNSswMDowMKkkeUMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMDJUMTU6NDQ6MTUrMDA6MDDYecH/AAAAAElFTkSuQmCC'
                            />
                        }
                    </div>
                    <Container fluid>
                        <Row>
                            <Col className={styles.titleColum}>
                                <div className={styles.bottomArea}>
                                    <div className={styles.title}>{article.title}</div>
                                    <div className={styles.excerpt}>{article.excerpt}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} className='d-block d-sm-none'>
                                <div className={styles.divider}></div>
                            </Col>
                        </Row>

                        <Row className={styles.infoRow}>
                            <Col className={styles.fullColum}>
                                <div className={styles.date}>{article.post_date.substring(0, 10)}</div>
                            </Col>
                            <Col className={styles.fullColum}>
                                <div className={styles.category}>{article.topic_title ? article.topic_title : '精選推介'}</div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </a>
        );
    };

    if (listData) {
        return (
            <Container fluid style={{ padding: 0 }}>
                <Row style={{ padding: 0, margin: 0 }}>
                    {listData && listData.map((article, index) => (
                        <Col key={index} xl={3} lg={3} xs={12} md={4} className={styles.colum2}>
                            {renderCardContent(article)}
                        </Col>
                    ))
                    }
                </Row>
            </Container>
        );
    }

    return (<></>);

}

export default Listing;